import {Item as DropdownItem} from '@wandb/weave/components/DropdownMenu';
import React, {ReactNode} from 'react';

type RunRowHeaderOptionProps = {
  icon: ReactNode;
  label: ReactNode;
  onSelect: () => void;
};

export function RowHeaderMenuOption({
  icon,
  label,
  onSelect,
}: RunRowHeaderOptionProps) {
  return (
    <DropdownItem onSelect={onSelect}>
      {icon} {label}
    </DropdownItem>
  );
}
